const reviews = [{
    id: 30,
    name: 'JÁCINT ENGEL',
    avatar_url: 'https://lh3.googleusercontent.com/a/AEdFTp7rawcl1pK2nh0obVqjmttJRbLjNLTC6ORBR6xh=w60-h60-p-rp-mo-br100',
    rating: 5,
    date: '3 weeks ago',
    text: ''
}, {
    id: 29,
    name: 'Linn Eggimann',
    avatar_url: 'https://lh3.googleusercontent.com/a/AEdFTp7CO9-L4IZzF6jpW2uOa6Wsuu1GhhZh3DpVdpQl=w60-h60-p-rp-mo-br100',
    rating: 5,
    date: '2 weeks ago',
    text: ''
}, {
    id: 28,
    name: 'José Antonio Madroñal Navarro',
    avatar_url: 'https://lh3.googleusercontent.com/a-/AD5-WCmOESkzRy464-kqQw5JTimhdaHhERkzjBZ0E3AvnJQ=w60-h60-p-rp-mo-ba4-br100',
    rating: 5,
    date: '2 weeks ago',
    text: ''
}, {
    id: 27,
    name: 'Nenad M (Mmedia Mreza)',
    avatar_url: 'https://lh3.googleusercontent.com/a-/ACNPEu95Z_950xSOSKDALU2UFxkFbScBzUoN4YJJUQm5Ndw=w75-h75-p-rp-mo-ba4-br100',
    rating: 5,
    date: '2 months ago',
    text: 'Upravo sam posadio drvo'
}, {
    id: 26,
    name: 'Astrid Schweiger',
    avatar_url: 'https://lh3.googleusercontent.com/a-/ACNPEu_X7L6sBdF2NOTuytYvfAbJqAoWBR2AIMffuRCGOQ=w75-h75-p-rp-mo-ba5-br100',
    rating: 5,
    date: '2 months ago',
    text: 'Also ich kenne das Unternehmen jetzt nicht persönlich und war noch nicht dort, nur online war ich dort und habe auch Bäume gepflanzt. Ich finde diese Idee toll, die Bäume echt nicht teuer, aber es wäre schön wenn man nachschauen kann wo der Baum oder die Bäume gepflanzt werden und wurden...'
}, {
    id: 24,
    name: 'Moewin J.',
    avatar_url: 'https://lh3.googleusercontent.com/a-/ACNPEu-CR0CFd8IBZJWFi4C88iWoLnegmMEnC2YL3_Ir3w=s40-c-c0x00000000-cc-rp-mo-br100',
    rating: 5,
    date: '3 months ago',
    text: 'Hatte eine Frage zum Schutzstaus der gepflanzten Bäume gestellt. Die Antwort kam schnell und das Konzept finde ich wundervoll, nachhaltig und an Mensch und Natur orientiert! Habe statt eines Rabattes bei einem Shop dann die Pflanzung eines Baumes durch Grow my Tree ausgewählt. Weil dies für den Planeten, für die Menschen und so für mich gut ist. Bäume kühlen den Planeten durch Verdunstungskälte, bieten Heimat für allerlei Getier und stärken Mutter Erde und all ihre Kinder!'
}, {
    id: 21,
    name: 'Nolan',
    avatar_url: 'https://lh3.googleusercontent.com/a/AItbvmmKjkRfwmsx5jBMnB99JDhqG-qtgzwzztKUyCyO=s40-c-c0x00000000-cc-rp-mo-br100',
    rating: 5,
    date: '4 months ago',
    text: ''
}, {
    id: 18,
    name: 'M K',
    avatar_url: 'https://lh3.googleusercontent.com/a/AItbvmlU4-5TyWIxNB4XSLzNMscBIV2Wx01XsebrwvXd=s40-c-c0x00000000-cc-rp-mo-br100',
    rating: 5,
    date: '4 months ago',
    text: 'Wonderful project! Participate!'
}, {
    id: 10,
    name: 'ZanthraX2008',
    avatar_url: 'https://lh3.googleusercontent.com/a/AItbvmkj3bej6hZAKzRhDoyfxpRZLl_qFSWN4x_NW4ft=s40-c-c0x00000000-cc-rp-mo-ba3-br100',
    rating: 5,
    date: '4 months ago',
    text: 'I bought a product and trees were planted through this company. I hope that this concept will continue to prevail. Continued success in your work.'
}, {
    id: 8,
    name: 'Katharina Loden',
    avatar_url: 'https://lh3.googleusercontent.com/a-/AFdZucoSvIMztWn24yyxHmllUzAf-Mn-HLIXEz7LikB-jA=s40-c-c0x00000000-cc-rp-mo-br100',
    rating: 5,
    date: '5 months ago',
    text: 'In my opinion, Grow My Tree represents one of the easiest, fastest, and infinitely scalable ways for anyone to make a valuable contribution. To my knowledge, there is no other company that makes it so easy for everyone to access absolutely trustworthy decarbonization, while also making it possible to strengthen friendships and family relationships. Thank you Grow My Tree!'
}, {
    id: 12,
    name: 'Barbara Steyer',
    avatar: 't',
    avatar_url: 'https://lh3.googleusercontent.com/a-/AFdZucp5jPPIF5ScI9Ri6YQzNZGGRuWLsrHcGd96UdtUKQ=s40-c-c0x00000000-cc-rp-mo-br100',
    rating: 5,
    date: '5 months ago',
    text: 'Great idea! Here everyone can take a big part in climate change with little effort.'
}, {
    id: 9,
    name: 'Birte Askotiris',
    rating: 5,
    avatar_url: 'https://lh3.googleusercontent.com/a/AItbvmmyp4pgcBLJ4ezzB8r9WioPuzNB8E-ItsEWnlgL=s40-c-c0x00000000-cc-rp-mo-br100',
    date: '5 months ago',
    text: 'I have purchased tree packs both for myself and as gifts. A great thing, I think and highly recommended. Grow My Tree is a very reliable and friendly company. Thanks.'
}, {
    id: 13,
    name: 'Wolfgang Beu',
    rating: 5,
    avatar_url: 'https://lh3.googleusercontent.com/a/AItbvmnwGX3hD-cMySCSl4JjFr5KR0XwYMxrqz9sOYTr=s40-c-c0x00000000-cc-rp-mo-br100',
    date: '5 months ago',
    text: 'A wonderful way to give a nice gift and do something really useful for this battered earth ❗️'
}, {
    id: 14,
    name: 'Terka Blaštíková',
    rating: 5,
    avatar_url: 'https://lh3.googleusercontent.com/a-/AFdZucr4zzLomflXVakMtu3fPVRMvdm1-TLzcpuVEG4Fkw=s40-c-c0x00000000-cc-rp-mo-ba4-br100',
    date: '5 months ago',
    text: 'They are good environmentalists today. Not all environmentalists are helpful during this difficult time... But these are.'
}, {
    id: 15,
    name: 'Louisa Panienka',
    avatar_url: 'https://lh3.googleusercontent.com/a/AItbvmnNML8ZqHgil8OBiewY66yXMXzL_TDViyR0zFun=s40-c-c0x00000000-cc-rp-mo-br100',
    rating: 5,
    date: '6 months ago',
    text: 'Thanks for the nice communication and support. Gladly again:)'
}, {
    id: 11,
    name: 'Irma Weder Bieri',
    avatar_url: 'https://lh3.googleusercontent.com/a-/AFdZucoFQGwnqZ8EkzfjvHppoYlM0NHFpXgiupz4MqMm=s40-c-c0x00000000-cc-rp-mo-br100',
    rating: 4,
    date: '6 months ago',
    text: 'We bought trees for dear friends as a farewell. We think it\'s a nice gesture. We would also like to be able to follow the planting. We don\'t know if it\'s possible. Pity'
}, {
    id: 17,
    name: 'Rafael Gómez',
    avatar_url: 'https://lh3.googleusercontent.com/a-/AFdZucrzB7GJ4wfM4lGp6go9vhWquTZPU7lS3no8g_y0VA=s40-c-c0x00000000-cc-rp-mo-ba2-br100',
    rating: 5,
    date: '6 months ago',
    text: 'Very good initiative.'
}, ];


const drawer = document.querySelector("#reviews-drawer");
const backdrop = document.querySelector("[data-reviews-backdrop]");
const openButton = document.querySelector("[data-open-reviews]");
const closeButton = document.querySelector("[data-close-reviews]");
const reviewsList = document.querySelector("[data-reviews-list]");
let lastFocusedElement = null;

function escapeHtml(value) {
  return value.replace(/[&<>'"]/g, (character) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#039;", '"': "&quot;"
  }[character]));
}

function renderReviews() {
  if (!reviewsList) return;
  reviewsList.innerHTML = reviews.map((review) => `
    <article class="review">
      <div class="review__head">
        <div class="review__avatar" aria-hidden="true">${escapeHtml(review.name.charAt(0))}</div>
        <div>
          <p class="review__name">${escapeHtml(review.name)}</p>
          <div class="review__meta">
            <span class="stars" aria-label="${review.rating} out of 5 stars">${"★".repeat(review.rating)}</span>
            <span>${escapeHtml(review.date)}</span>
          </div>
        </div>
      </div>
      <p class="review__text">${escapeHtml(review.text)}</p>
    </article>
  `).join("");
}

function openReviews() {
  if (!drawer || !backdrop) return;
  lastFocusedElement = document.activeElement;
  backdrop.hidden = false;
  requestAnimationFrame(() => backdrop.classList.add("is-visible"));
  drawer.classList.add("is-open");
  drawer.setAttribute("aria-hidden", "false");
  document.body.classList.add("reviews-open");
  closeButton?.focus();
}

function closeReviews() {
  if (!drawer || !backdrop) return;
  drawer.classList.remove("is-open");
  drawer.setAttribute("aria-hidden", "true");
  backdrop.classList.remove("is-visible");
  document.body.classList.remove("reviews-open");
  window.setTimeout(() => { backdrop.hidden = true; }, 250);
  if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus();
}

function keepFocusInsideDrawer(event) {
  if (event.key !== "Tab" || !drawer?.classList.contains("is-open")) return;
  const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')];
  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
  if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
}

renderReviews();
openButton?.addEventListener("click", openReviews);
closeButton?.addEventListener("click", closeReviews);
backdrop?.addEventListener("click", closeReviews);
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeReviews();
  keepFocusInsideDrawer(event);
});
